module.exports = __webpack_public_path__ + "img/img_size3_test.b71049f6.png";